'use strict';

module Patersons {

    export interface ResearchSubscriptionsScope extends ng.IScope {
        researchSubscriptionsForm: ng.IFormController;
        parentController: AbstractController;
        events: Patersons.ResearchSubscriptionsViewCtrl;
        hasChanged: boolean;
        isLoading: boolean;
        isSubmitted: boolean;
        isSaving: boolean;
        isError: boolean;
        subscribedPublications: SubscribedResearchPublication[]
        isAustralianInvestorSubscribed: boolean;
        isMorningMarketSubscribed: boolean;
        isWeeklyMarketWrapSubscribed: boolean;
    }

    export class ResearchSubscriptionsViewCtrl extends MyDetailsBaseCtrl {
        scope: Patersons.ResearchSubscriptionsScope;
        myDetailsService: Patersons.MyDetailsService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'myDetailsService','navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, myDetailsService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.myDetailsService = myDetailsService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.hasChanged = false;
            this.scope.isSubmitted = false;
            this.scope.isError = false;
            this.scope.isLoading = false;
            this.getResearchSubscriptions();
        }

        setChanged(){
            this.scope.hasChanged = true;
        }

        onSave() {
            this.scope.isError = false;
            this.scope.isSubmitted = false;
            this.scope.isSaving = true;
            this.myDetailsService.updateResearchSubscriptions(this.scope.subscribedPublications)
                .then((result) => {
                        this.scope.isSubmitted = result.status == 200;
                    },
                    (reason) => { // error handling
                        this.scope.isError = true;
                        this.myDetailsService.errorHandler = reason.data;
                    }).finally(() => {
                        this.scope.isSaving = false;
                        this.scope.hasChanged = false;
                });
        }

        getResearchSubscriptions() {
            this.scope.isLoading = true;


            this.myDetailsService.getResearchSubscriptions()
                .then((result) => {
                    var data: any= result;
                    this.scope.subscribedPublications = data
                    
                    this.scope.isLoading = false;
                },
                (reason) => { // error handling
                    this.scope.isError = true;
                    this.scope.isLoading = false;
                });
        }
        
    }
}
